import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    GET_METER_SLABS,
    GET_METER_SLABS_SUCCESS,
    GET_METER_SLABS_FAILURE,
    GET_METER_SLABS_BY_HEAD,
    GET_METER_SLABS_BY_HEAD_SUCCESS,
    GET_METER_SLABS_BY_HEAD_FAILURE,
    GET_METER_SLAB_DETAILS,
    GET_METER_SLAB_DETAILS_SUCCESS,
    GET_METER_SLAB_DETAILS_FAILURE,
    CREATE_METER_SLAB,
    CREATE_METER_SLAB_SUCCESS,
    CREATE_METER_SLAB_FAILURE,
    CREATE_BULK_METER_SLABS,
    CREATE_BULK_METER_SLABS_SUCCESS,
    CREATE_BULK_METER_SLABS_FAILURE,
    UPDATE_METER_SLAB,
    UPDATE_METER_SLAB_SUCCESS,
    UPDATE_METER_SLAB_FAILURE,
    UPDATE_METER_SLAB_STATUS,
    UPDATE_METER_SLAB_STATUS_SUCCESS,
    UPDATE_METER_SLAB_STATUS_FAILURE,
    DELETE_METER_SLAB,
    DELETE_METER_SLAB_SUCCESS,
    DELETE_METER_SLAB_FAILURE
} from '../../../actions/index.types';
import {
    getMeterSlabsReq,
    getMeterSlabsByHeadReq,
    getMeterSlabDetailsReq,
    createMeterSlabReq,
    createBulkMeterSlabsReq,
    updateMeterSlabReq,
    updateMeterSlabStatusReq,
    deleteMeterSlabReq
} from '../../../../axios/request/SocietyPortal/MeterSlabReqs/MeterSlabReqs';

// Get All Meter Slabs Saga
function* getMeterSlabsSaga(action) {
    try {
        const response = yield getMeterSlabsReq(action);
        if (response.success === true) {
            yield put({ type: GET_METER_SLABS_SUCCESS, data: response });
        } else {
            yield put({ type: GET_METER_SLABS_FAILURE, data: response.data });
            toast.error(response.message || "Failed to fetch meter slabs");
        }
    } catch (error) {
        yield put({ type: GET_METER_SLABS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Get Meter Slabs by Head Saga
function* getMeterSlabsByHeadSaga(action) {
    try {
        const response = yield getMeterSlabsByHeadReq(action);
        if (response.success === true) {
            yield put({ type: GET_METER_SLABS_BY_HEAD_SUCCESS, data: response });
        } else {
            yield put({ type: GET_METER_SLABS_BY_HEAD_FAILURE, data: response.data });
        }
    } catch (error) {
        yield put({ type: GET_METER_SLABS_BY_HEAD_FAILURE, data: error });
    }
}

// Get Meter Slab Details Saga
function* getMeterSlabDetailsSaga(action) {
    try {
        const response = yield getMeterSlabDetailsReq(action);
        if (response.success === true) {
            yield put({ type: GET_METER_SLAB_DETAILS_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_METER_SLAB_DETAILS_FAILURE, data: response.data });
            toast.error(response.message || "Failed to fetch slab details");
        }
    } catch (error) {
        yield put({ type: GET_METER_SLAB_DETAILS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Create Meter Slab Saga
function* createMeterSlabSaga(action) {
    try {
        const response = yield createMeterSlabReq(action);
        if (response.success === true) {
            yield put({ type: CREATE_METER_SLAB_SUCCESS, data: response.data });
            toast.success(response.message || "Meter slab created successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: CREATE_METER_SLAB_FAILURE, data: response.data });
            toast.error(response.message || "Failed to create meter slab");
        }
    } catch (error) {
        yield put({ type: CREATE_METER_SLAB_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Bulk Create Meter Slabs Saga
function* createBulkMeterSlabsSaga(action) {
    try {
        const response = yield createBulkMeterSlabsReq(action);
        if (response.success === true) {
            yield put({ type: CREATE_BULK_METER_SLABS_SUCCESS, data: response.data });
            toast.success(response.message || "Meter slabs created successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: CREATE_BULK_METER_SLABS_FAILURE, data: response.data });
            toast.error(response.message || "Failed to create meter slabs");
        }
    } catch (error) {
        yield put({ type: CREATE_BULK_METER_SLABS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Meter Slab Saga
function* updateMeterSlabSaga(action) {
    try {
        const response = yield updateMeterSlabReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_METER_SLAB_SUCCESS, data: response.data });
            toast.success(response.message || "Meter slab updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: UPDATE_METER_SLAB_FAILURE, data: response.data });
            toast.error(response.message || "Failed to update meter slab");
        }
    } catch (error) {
        yield put({ type: UPDATE_METER_SLAB_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Meter Slab Status Saga
function* updateMeterSlabStatusSaga(action) {
    try {
        const response = yield updateMeterSlabStatusReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_METER_SLAB_STATUS_SUCCESS, data: response.data });
            toast.success(response.message || "Slab status updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: UPDATE_METER_SLAB_STATUS_FAILURE, data: response.data });
            toast.error(response.message || "Failed to update slab status");
        }
    } catch (error) {
        yield put({ type: UPDATE_METER_SLAB_STATUS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Delete Meter Slab Saga
function* deleteMeterSlabSaga(action) {
    try {
        const response = yield deleteMeterSlabReq(action);
        if (response.success === true) {
            yield put({ type: DELETE_METER_SLAB_SUCCESS, data: response.data });
            toast.success(response.message || "Meter slab deleted successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: DELETE_METER_SLAB_FAILURE, data: response.data });
            toast.error(response.message || "Failed to delete meter slab");
        }
    } catch (error) {
        yield put({ type: DELETE_METER_SLAB_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

export default function* MeterSlabSaga() {
    yield takeLatest(GET_METER_SLABS, getMeterSlabsSaga);
    yield takeLatest(GET_METER_SLABS_BY_HEAD, getMeterSlabsByHeadSaga);
    yield takeLatest(GET_METER_SLAB_DETAILS, getMeterSlabDetailsSaga);
    yield takeLatest(CREATE_METER_SLAB, createMeterSlabSaga);
    yield takeLatest(CREATE_BULK_METER_SLABS, createBulkMeterSlabsSaga);
    yield takeLatest(UPDATE_METER_SLAB, updateMeterSlabSaga);
    yield takeLatest(UPDATE_METER_SLAB_STATUS, updateMeterSlabStatusSaga);
    yield takeLatest(DELETE_METER_SLAB, deleteMeterSlabSaga);
}
